import React, { useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoIosArrowBack } from "react-icons/io";
import "react-pro-sidebar/dist/css/styles.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setShowSidebar,
  useShowSidebar,
} from "../../../redux/reducers/SidebarReducer";
import CardPaymentForm from "../../../components/CardPaymentForm";
import {
  useCouponDetails,
  usePaymentSuccess,
  useSuccess,
} from "../../../redux/reducers/SubscriptionReducer";
import {
  useData,
  useUserSubscription,
} from "../../../redux/reducers/SubscriptionReducer";
import {
  addSubscription,
  updateSubscription,
} from "../../../redux/sagas/subscription/paymentSaga";
import { useDispatchEffect, useQuery } from "../../../utils/hooks";
import "./paymentdashboardSubscription.scss";
import { fetchSubscriptions } from "../../../redux/sagas/subscription/fetchSaga";

const PaymentDashboardScreen = () => {
  const navigate = useNavigate();
  const showSidebar = useShowSidebar();
  const dispatch = useDispatch();
  const subscriptions = useData();
  const userSubscription = useUserSubscription();
  const isSubscribed = useSuccess();
  const paymentSuccess = usePaymentSuccess();
  const couponDetails = useCouponDetails();

  useDispatchEffect(fetchSubscriptions, null, subscriptions?.length == 0);

  const query = useQuery();
  const subscription = query.get("subscription");
  const selected = subscriptions.find(
    (item) => item.id == Number(subscription)
  );

  useEffect(() => {
    if (paymentSuccess) {
      navigate(`/student/dashboard-subscription`);
    }
  }, [paymentSuccess]);

  const onTokenGenerated = ({ token, couponCode }) => {
    const params = {
      sub_id: Number(subscription),
      token: token,
      coupon: couponCode,
    };
    if (userSubscription && userSubscription.stripe_subscription_id)
      dispatch(updateSubscription(params));
    else dispatch(addSubscription(params));
  };
  let disc = couponDetails?.percent_off
    ? (selected.price?.price * couponDetails?.percent_off) / 100
    : couponDetails?.amount_off / 100;
  return (
    <div className="section has-light-background">
      <div className="columns">
        <div className="column"></div>
      </div>
      <div className="columns">
        <div className="column is-two-thirds">
          <button
            className="Toggle_btn"
            onClick={() => dispatch(setShowSidebar(!showSidebar))}
          >
            {showSidebar ? <GiHamburgerMenu /> : <GiHamburgerMenu />}
          </button>
          <div className="payment-header">
            <a className="backlink" onClick={(_) => navigate(-1)}>
              <IoIosArrowBack />
            </a>
            <p className="step-indicator">Step 2 of 2</p>
            <h1 className="trial-heading">Start Your 7-Day Free Trial</h1>
            <p className="trial-subtext">No charge today &bull; Billing starts after 7 days</p>
          </div>
          <hr className="section-separator" />
          <div className="pricing-info">
            <p className="pricing-line">
              <span className="pricing-label">Today&apos;s charge:</span>{" "}
              <span className="pricing-value pricing-free">$0</span>
            </p>
            <p className="pricing-line">
              <span className="pricing-label">After trial:</span>{" "}
              <span className="pricing-value">
                $
                {couponDetails?.valid
                  ? disc > selected.price?.price
                    ? "0"
                    : selected.price?.price - disc
                  : selected.price?.price}
              </span>
              {couponDetails?.valid && (
                <span className="pricing-original">
                  <s>${selected.price?.price}</s>
                  {" "}
                  <span className="pricing-off">
                    {disc > selected.price?.price
                      ? "100"
                      : ((disc / selected.price?.price) * 100)?.toFixed(2)}
                    % off
                  </span>
                </span>
              )}
            </p>
          </div>
          <hr className="section-separator" />
          <CardPaymentForm onSuccess={onTokenGenerated} />
        </div>
      </div>
    </div>
  );
};

export default PaymentDashboardScreen;
